import { FaqPages, FaqTypeEnum } from '__generatedTypes__/globalTypes'
import { FaqTypeOption } from './types'

export const FAQ_TAB = {
  id: 'FAQ',
  title: 'FAQ',
}

export const FAQ_TYPE_OPTIONS: FaqTypeOption[] = [
  { id: FaqTypeEnum.Standard, title: 'Standard' },
  { id: FaqTypeEnum.HigherScore, title: 'Higher Score' },
]

export const FAQ_ALLOWED_TYPES_BY_PAGE: Partial<Record<FaqPages, FaqTypeEnum[]>> = {
  [FaqPages.HomePage]: [FaqTypeEnum.Standard, FaqTypeEnum.HigherScore],
  [FaqPages.UpgradePage]: [FaqTypeEnum.Standard, FaqTypeEnum.HigherScore],
}

export const getFaqAllowedTypes = (page: FaqPages): FaqTypeEnum[] =>
  FAQ_ALLOWED_TYPES_BY_PAGE[page] ?? [FaqTypeEnum.Standard]

export const getFaqTypeOption = (type: FaqTypeEnum): FaqTypeOption =>
  FAQ_TYPE_OPTIONS.find((option) => option.id === type) ?? FAQ_TYPE_OPTIONS[0]

export const getFaqTypeSelectItems = (allowedTypes: FaqTypeEnum[]): FaqTypeOption[] =>
  FAQ_TYPE_OPTIONS.filter((option) => allowedTypes.includes(option.id))
